import React, { Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { PageLayout } from './components/layout';
import { About } from './pages/about/About';
import { Home } from './pages/home/Home';
import { Products } from './pages/products/Products';
import { Product } from './pages/products/Product';
import { Work } from './pages/works/Work';
import { Works } from './pages/works/Works';

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<PageLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/our-products" element={<Products />} />
            <Route path="/our-products/:slug" element={<Product />} />
            <Route path="/our-works" element={<Works />} />
            <Route path="/our-works/:slug" element={<Work />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
